
























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PermintaanKomponenDarahPage from "@/pages/pemeriksaan_ranap/PermintaanKomponenDarahPage.vue";
import OrderDarahList from "./OrderDarahList.vue";
import PembatalanKomponenDarahList from "./PembatalanKomponenDarahList.vue";
import CardHasilBankDarah from "@/components/pemeriksaan/tabs/penunjang/CardHasilBankDarah.vue";
import { ORDER_DARAH_SUB_TABS, ORDER_DARAH_TABS } from "./orderDarah.config";
import { scrollTabIntoView } from "@/utils/scrollTabIntoView";

@Component({
  components: {
    PermintaanKomponenDarahPage,
    OrderDarahList,
    CardHasilBankDarah,
    PembatalanKomponenDarahList
  }
})
export default class TabOrderDarah extends Vue {
  @Prop() readonly register!: string;

  @Prop() readonly rm!: string;

  @Prop({ default: null }) readonly deepLink!: any;

  @Prop({ type: Boolean, default: false })
  readonly showMonitoringShortcut!: boolean;

  tabs = ORDER_DARAH_TABS;

  innerTab = ORDER_DARAH_TABS[0].elemId;

  @Watch("innerTab")
  onInnerTabChange() {
    this.$nextTick(() => scrollTabIntoView(this.$el));
  }

  @Watch("deepLink", { immediate: true })
  onDeepLink(payload: any) {
    if (
      !payload ||
      payload.topTab !== "tab-penunjang" ||
      !ORDER_DARAH_SUB_TABS.includes(payload.elemId)
    ) {
      return;
    }

    this.innerTab = payload.elemId;

    if (!payload.subTab) return;

    this.$nextTick(() => {
      scrollTabIntoView(document.getElementById(payload.subTab));
    });
  }
}
